var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReceivedTextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EDF7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10h16v12H11.17L10 23.17V10zm0-2c-1.1 0-1.99.9-1.99 2L8 28l4-4h14c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2H10zm2 10h8v2h-8v-2zm0-3h12v2H12v-2zm0-3h12v2H12v-2z",
    fill: "#4CAF50"
  })));
}

export default __webpack_public_path__ + "d3d63ac0feb1ac25472a0235e121b477.svg";
export { SvgReceivedTextIcon as ReactComponent };